import type { Uuid } from '@sibe/utilities/common';
import type { HsBox } from '../../math-new/shapes/box.class';
import type { HsSphere } from '../../math-new/shapes/sphere.class';
import type { HsGraphicsBuffer } from '../../graphic-render-new/types/graphic-buffer.type';
import type { HsGeometryType } from './geometry-type.enum';
import { HsIndexedGeometry } from './indexed-geometry.class';

export class HsTexturedIndexedGeometry extends HsIndexedGeometry {
  constructor(
    public readonly uuid: Uuid,
    public readonly geometryType: HsGeometryType,
    public readonly boundingBox: HsBox,
    public readonly boundingSphere: HsSphere,
    public readonly positionArrayLength: number,
    public readonly normalArrayLength: number,
    public readonly indexArrayLength: number,
    public readonly buffer: HsGraphicsBuffer,
    public readonly indexBuffer: HsGraphicsBuffer
  ) {
    super(uuid, geometryType, boundingBox, boundingSphere, positionArrayLength, indexArrayLength, buffer, indexBuffer);
  }
}
